import React from 'react';
import { Checkbox } from '@vtblife/uikit';
import { OptionType } from '@vtblife/uikit/legacy';

import { FurnitureOption } from '@search/filter-enums/enums/FurnitureOption';

import { FurnitureFilter } from '../../../../models/Filter';

interface IFurnitureButtonFilter {
    filter: FurnitureFilter;
    handleChange: (filter: FurnitureFilter) => void;
    classNameGroup?: string;
    isRoom?: boolean;
}

const OPTIONS_TYPE: OptionType<FurnitureOption>[] = [
    { label: 'Без мебели', value: FurnitureOption.NO },
    { label: 'С мебелью', value: FurnitureOption.ALL },
    { label: 'Мебель на кухне', value: FurnitureOption.KITCHEN }
];

export const FurnitureButtonFilterView: React.FC<IFurnitureButtonFilter> = ({
    filter,
    handleChange,
    isRoom = false,
    classNameGroup
}) => {
    const onChange = React.useCallback((value: boolean, option: FurnitureOption) => {
        if (value && option === FurnitureOption.NO) {
            handleChange(new FurnitureFilter([ FurnitureOption.NO ]));
            return;
        }

        const filters = new Set(filter.furnitures);

        filters[value ? 'add' : 'delete'](option);
        if (value && option !== FurnitureOption.NO && filters.has(FurnitureOption.NO)) {
            filters.delete(FurnitureOption.NO);
        }

        handleChange(new FurnitureFilter(Array.from(filters)));
    }, [ handleChange, filter.furnitures ]);

    return (
        <div className={classNameGroup}>
            {OPTIONS_TYPE.filter(option => {
                if (isRoom) return option.value !== FurnitureOption.KITCHEN;

                return true;
            }).map(type => (
                <div key={type.value} style={{ width: 'max-content' }}>
                    <Checkbox
                        name={type.label}
                        onChange={value => onChange(value, type.value)}
                        value={filter.furnitures.includes(type.value)}
                        variant='filter'
                        block
                    >
                        {type.label}
                    </Checkbox>
                </div>
            ))}
        </div>
    );
};
